import {
  GET_RAFFLE_RESULTS_REQUEST,
  GET_RAFFLE_RESULTS_SUCCESS,
  GET_RAFFLE_RESULTS_FAILURE,
  SET_RAFFLE_LIST_POSITION,
} from 'Store/constants';
  
    
const initialState = {
  data: null,
  isLoading: null,
  error: null,
  scrollPosition: 0,
};
    
export default (state = initialState, action) => {
  switch (action.type) {
    case GET_RAFFLE_RESULTS_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_RAFFLE_RESULTS_SUCCESS:
      return { ...state, data: action.payload, isLoading: false, error: null };
    case GET_RAFFLE_RESULTS_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case SET_RAFFLE_LIST_POSITION:
      return { ...state, scrollPosition: action.payload };
    default:
      return state;
  }
};